import { useEffect, useState, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";
import { supabase } from "../../supabase";
import "./Payment.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "/api";

export default function KakaoBillingSuccess() {
  const { t } = useTranslation();
  const { user, refreshProfile } = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user?.id) return;

    const params = new URLSearchParams(location.search);
    const billingKey = params.get("billingKey");
    const code = params.get("code");
    const message = params.get("message");
    const plan = sessionStorage.getItem("kakao_plan") || "STANDARD";

    if (code) {
      setStatus("error");
      setError(message || `Billing failed (${code})`);
      return;
    }

    if (!billingKey) {
      setStatus("error");
      setError("Missing billingKey");
      return;
    }

    async function processBilling() {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) { history.push("/login"); return; }

        const res = await fetch(`${API_BASE}/portone/billing-key`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${session.access_token}`,
          },
          body: JSON.stringify({
            billingKey,
            customerKey: String(user.id),
            plan,
          }),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          setError(err.detail?.message || err.detail?.pgMessage || (typeof err.detail === "string" ? err.detail : "") || "결제에 실패했습니다. 카드 잔액 또는 한도를 확인해 주세요.");
          setStatus("error");
          return;
        }

        sessionStorage.removeItem("kakao_plan");
        await refreshProfile();
        setStatus("success");
      } catch (e) {
        console.error("kakao billing error", e);
        setError("Payment processing failed");
        setStatus("error");
      }
    }

    processBilling();
  }, [user?.id]);

  return (
    <div className="payment-result-page">
      <div className="payment-result-card">
        {status === "loading" && (
          <>
            <div className="payment-icon">...</div>
            <h1>{t("payment.processing")}</h1>
            <p>{t("payment.processingDesc")}</p>
          </>
        )}
        {status === "success" && (
          <>
            <div className="payment-icon success">O</div>
            <h1>{t("payment.successTitle")}</h1>
            <p>{t("payment.successMessage")}</p>
            <button className="btn-primary" onClick={() => history.push("/mypage")}>
              {t("nav.mypage")}
            </button>
          </>
        )}
        {status === "error" && (
          <>
            <div className="payment-icon cancel">X</div>
            <h1>{t("payment.cancelTitle")}</h1>
            <p>{error}</p>
            <button className="btn-primary" onClick={() => history.push("/pricing")}>
              {t("nav.pricing")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
